<template>
  <div
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
    ref="r"
  >
    <slot></slot>
  </div>
  <Teleport to="body">
    <div
      class="tooltip bs-tooltip-auto fade show"
      v-if="show && visible"
      ref="rt"
    >
      <div
        class="tooltip-arrow"
        data-popper-arrow
      ></div>
      <div class="tooltip-inner">{{ text }}</div>
    </div>
  </Teleport>
</template>
<script setup>
import { onUnmounted, ref, shallowRef, useTemplateRef, watch } from 'vue'
import { createPopper } from '@popperjs/core'
import { throttledRef } from '@vueuse/core'

const _visible = shallowRef(false)
const visible = throttledRef(_visible, 350)
const hideTimeout = ref(null)

const r = useTemplateRef('r')
const rt = useTemplateRef('rt')
const p = ref(null)

const props = defineProps({
  text: String,
  show: { type: Boolean, default: true },
  hideDelay: { type: Number, default: 0 },
})

function onMouseOver() {
  if (hideTimeout.value) {
    clearTimeout(hideTimeout.value)
    hideTimeout.value = null
  }
  _visible.value = true
}

function onMouseLeave() {
  const delay = hideTimeout.value ? 0 : (props.hideDelay ?? 0)
  if (delay <= 0) {
    _visible.value = false
    return
  }
  hideTimeout.value = setTimeout(() => {
    _visible.value = false
    hideTimeout.value = null
  }, delay)
}

watch(
  [rt, r],
  async ([rt, r]) => {
    if (rt && r) {
      p.value = createPopper(r, rt)
    }
  },
  {
    immediate: true,
  }
)
onUnmounted(() => {
  if (hideTimeout.value) {
    clearTimeout(hideTimeout.value)
  }
  if (p.value) {
    p.value.destroy()
  }
})
watch(
  visible,
  vis => {
    if (vis && p.value) {
      p.value.update()
    }
  },
  {
    immediate: true,
  }
)
</script>
